const toNumber = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

export const getDiffByPercent = ({
  current,
  previous,
  fractionDigits = 2,
  epsilon = 1e-6,
  fallback = 0,
}) => {
  if (current === undefined || previous === undefined) return fallback;
  const c = toNumber(current);
  const p = toNumber(previous);

  if (Math.abs(p) < epsilon) {
    if (Math.abs(c) < epsilon) return 0;
    return c > 0 ? 100 : -100;
  }

  const res = ((c - p) / Math.abs(p)) * 100;
  if (!Number.isFinite(res)) return 0;

  return Number(res.toFixed(fractionDigits));
};